/**
 * IMPORTS
 */

import { useCallback } from "react";

import { TriangleAlert, X } from "lucide-react";
import { toast } from "react-toastify";

// components
import { Button } from "@components/button/button";

// typings
import { PegarTarefaModalProps } from "@pages/producao/components/pegar-tarefa-modal/index.d";

// hooks / react-query
import { useUpdateTarefa } from "@/hooks/minhas-tarefas/use-update-tarefa";
import { useStatusRemessa } from "@/hooks/remessas/status-remessa-do-cliente";

// hooks / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

const PegarTarefaModal = ({ idRemessa, handleToggleCreateActvityModal }: PegarTarefaModalProps) => {
  const { user } = useStoreZustandUserAuth();

  const { mutate: mutateUseUpdateTarefa, isPending } = useUpdateTarefa();

  const { statusRemessaAsync: solicitarRemessaAsync } = useStatusRemessa();

  const handleConfirmar = useCallback(() => {
    if (!user?.id) {
      toast.error("Usuário não autenticado.");
      return;
    }

    mutateUseUpdateTarefa(
      {
        id_remessa: Number(idRemessa),
        payload: {
          user_id_executor: user.id,
          situacao: "em_producao",
          status: "em_producao",
          data_inicio_producao: new Date(Date.now() - 3 * 60 * 60 * 1000), // 3 horas em ms
        },
      },
      {
        onSuccess: async () => {
          await solicitarRemessaAsync({
            id_remessa: idRemessa,
            payload: { status: "em_producao" },
          });

          handleToggleCreateActvityModal();
        },
        onError: () => {
          handleToggleCreateActvityModal();
        },
      }
    );
  }, [
    idRemessa,
    user,
    mutateUseUpdateTarefa,
    handleToggleCreateActvityModal,
    solicitarRemessaAsync,
  ]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="max-h-[90vh] w-[400px] space-y-5 rounded-xl bg-white px-6 py-6 shadow-shape">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-zinc-800">Confirmar Ação</h2>
          <button onClick={handleToggleCreateActvityModal}>
            <X className="size-5 text-zinc-400" />
          </button>
        </div>

        {/* Icone + Texto */}
        <div className="flex flex-col items-center gap-2 text-center">
          <TriangleAlert className="text-yellow-500" size={32} />
          <p className="text-base font-medium text-zinc-700">Deseja realmente pegar esta tarefa?</p>
        </div>

        {/* Botões */}
        <div className="w-full justify-end gap-2 pt-4">
          <Button className="w-full" onClick={handleConfirmar} disabled={isPending}>
            {isPending ? "Atribuindo..." : "Confirmar"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { PegarTarefaModal };
